import { PhoneType } from "@redotech/redo-support-common/support/phone/phone-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createSupportPhoneSubscription = {
  name: "createSupportPhoneSubscription" as const,
  input: z.object({ phoneType: createEnum(PhoneType) }),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().url().optional(),
  }),
};
